export default __webpack_public_path__ + "static/undraw_Team-802a89cf0c70299b51eeb7a81e2201db.svg";